import Loading from '../../../Common/Loading';
import { useCallsChartsDataContext } from './hooks/useCallsChartsDataContext';
import { CallsTimes } from './CallsTimes';
import { CallsTimesEvolution } from './CallsTimesEvolution';
import { CallsTimesMonthlyEvolution } from './CallsTimesMonthlyEvolution';

export const Charts = () => {
    const { isLoading } = useCallsChartsDataContext();

    if (isLoading) {
        return <Loading />;
    }

    return (
        <>
            <CallsTimes />
            <div className="charts-side-by-side-dashboards">
                <CallsTimesEvolution />
                <CallsTimesMonthlyEvolution />
            </div>
        </>
    );
};
